var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 54,
    viewBox: "0 0 64 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.328125 3.95508H59.1622C60.2701 3.95508 61.3325 4.39266 62.1159 5.17156C62.8993 5.95046 63.3393 7.00688 63.3393 8.10841V49.0264H0.328125V3.95631V3.95508Z",
    fill: "#2E75FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3503 6.0421V4.29824C16.3503 3.15828 15.8948 2.06501 15.0841 1.25893C14.2735 0.452852 13.1739 1.5625e-07 12.0274 1.5625e-07H5.19113C4.5536 -0.000161142 3.92227 0.124562 3.33322 0.367034C2.74417 0.609507 2.20893 0.964984 1.75807 1.41316C1.30721 1.86134 0.94956 2.39344 0.705548 2.97908C0.461537 3.56472 0.335937 4.19241 0.335938 4.82632V49.7208C0.335938 50.7631 0.752339 51.7627 1.49354 52.4997C2.23475 53.2366 3.24004 53.6507 4.28826 53.6507H59.1268C60.2471 53.6507 61.3215 53.2082 62.1137 52.4205C62.9058 51.6329 63.3509 50.5646 63.3509 49.4507V14.1596C63.3509 13.005 62.8896 11.8977 62.0685 11.0812C61.2473 10.2648 60.1337 9.80614 58.9724 9.80614H20.1359C19.1319 9.80614 18.169 9.40957 17.4591 8.70368C16.7491 7.99779 16.3503 7.04039 16.3503 6.0421Z",
    fill: "#8EB5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.acf9b84e7fcb78fbb691a8ea94f9efdf.svg";
export { ForwardRef as ReactComponent };